import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
// import {
//   dbsCertificates,
//   dbsDocumentName,
// } from "../../../helpers/DocumentsList";
import { Link } from "react-router-dom";
// import constants from "../../../constants";
import LoadMoreList from "../../../services/LoadMoreList";
import { redirectUrl } from "../../../services/GlobalUrls";

const DBSTableNoMobile = (props) => {
  const [dbsdocuments, SetDbsdocuments] = useState([]);
  const [setFilter] = useState("");
  const [inputSearchValue, setInputValue] = useState("");

  useEffect(() => {
    SetDbsdocuments(props.dbsdocuments);
  }, [props.dbsdocuments]);

  const dateDiffrence = (date) => {
    const date1 = new Date();
    const date2 = new Date(splitDateToFormat(date));
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const splitDateToFormat = (date) => {
    let splitDate = date.split("-");
    let formattedDate = splitDate[2] + "-" + splitDate[1] + "-" + splitDate[0];
    return formattedDate;
  };

  const matchesSearchTextContent = (dbsdocuments) => {
    const searchText = inputSearchValue ? inputSearchValue.toLowerCase() : "";
    if (
      dbsdocuments &&
      dbsdocuments.cnd_address_created_date &&
      dbsdocuments.cnd_address_address &&
      dbsdocuments.cnd_dbs_status
    ) {
      return (
        dbsdocuments.cnd_address_created_date
          .toLowerCase()
          .includes(searchText) ||
        dbsdocuments.cnd_address_address.toLowerCase().includes(searchText) ||
        dbsdocuments.cnd_dbs_status.toLowerCase().includes(searchText)
      );
    }
  };
  // Filter applied jobs based on the search text
  const filterRowsNo = dbsdocuments
    ? dbsdocuments.filter(matchesSearchTextContent)
    : [];

  return (
    <React.Fragment>
      <div className="m-b30 wrapper">
        {/* Search Start */}
        <div className="container">
          <div className="row">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              {/* <label class="form-control-label text-right" for="search">
                Search
              </label> */}
              <div class="form-group form-group-default">
                <input
                  type="text"
                  name="search"
                  class="form-control "
                  placeholder="Enter here"
                  onInput={(event, value) => {
                    setInputValue(event.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        {/* Search End */}
        <div className="col-lg-12 col-md-12 m-b0 wrapper">
          <LoadMoreList
            data={filterRowsNo}
            initialCount={5}
            noDataMessage="No Result Found"
            renderItem={(dbsdoc, i) => (
              <ul
                className="nav navbar-nav border border-grey p-4 mb-2"
                style={{ borderRadius: "20px" }}
                key={i}
              >
                <li className="text-dark">
                  <i className="fa fa-calendar-o mr-1 text-primary"></i>{" "}
                  {dbsdoc.cnd_address_created_date}
                </li>
                <li className="text-dark">
                  <i className="fa fa-map-marker mr-1 text-primary"></i>{" "}
                  {dbsdoc.cnd_address_address}
                </li>
                <li className="text-dark">
                  <i className="fa fa-circle-o-notch mr-1 text-primary"></i>{" "}
                  {dbsdoc.cnd_dbs_status}
                </li>
              </ul>
            )}
          />
          <button
            href="#"
            onClick={() => redirectUrl("/identity-document")}
            className="pull-right btn btn-primary mr-2"
          >
            Next
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    dbsdocuments: state.dbsdocuments.dbsdocuments,
  };
};

export default connect(mapStateToProps)(DBSTableNoMobile);
